<template>
    <div>
        <div v-for="item in projNow" :key="item.id">
            <!-- Title page -->
            <div>
                <div class="title-img">
                    <img :src="require('../../assets/designProjects/' + item.img)">
                    <div class="title-img-overlay"></div>
                </div>
                <b-container fluid class="title-des">
                    <b-col class="col-lg-3 col-md-4 col-sm-6">
                        <h1 class="text-info text-left">{{ item.title }}</h1>
                        <p class="text-white">{{ item.description }}</p>
                    </b-col>
                </b-container>
            </div>
            <!-- Header -->
            <Header></Header>
            <!-- Project Info -->
            <b-container class="d-none d-lg-block d-xl-block content-left">
                <b-col class="col-lg-2">
                    <div class="my-5">    
                        <h5 class="text-info">Type</h5>
                        <p>{{ item.type }} <br>{{ item.skill }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Duration</h5>
                        <p>{{ item.time }} <br>{{ item.duration }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Team</h5>
                        <p>Akari Takada <br>Jack Eichenlaub <br>Victor Verboom <br>Tomasso Silluzio <br>Nancy Luu <br>Miriam Lluva</p>
                    </div>
                    <!-- <div class="my-5">
                        <h5 class="text-info">Skills</h5>
                        <p>edit here</p>
                    </div> -->
                </b-col>
            </b-container>
            <!-- Overview -->
            <b-container class="my-5">
                <h2 class="my-4 text-light">Overview</h2>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Context</h5>
                            <h3>"To me, gaming means escape."</h3>
                            <p>Boys with Duchenne Muscular Disease (DMD) face physical challenges due to a rapid decline of muscle function. To these boys, gaming is a gateway to independence. </p>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/evo/gaming-dmd.jpg" alt="">
                        <p class="text-right w-100"><small>Source: Defeat Duchenne Canada</small></p>
                    </b-row>
                </b-col>
            </b-container>
            <!-- Problem -->
            <b-container class="bg-custom py-5 my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Problem</h5>
                            <h3>Two extremes.</h3>
                            <p>Mainstream controllers are desireable but uncomfortable. Untraditional adaptive controllers are highly-customizable but costly and complex.</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col md class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/traditional-controller.jpg" alt=""></b-col>
                        <b-col md class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/adaptive-controller.png" alt=""></b-col>
                    </b-row>
                </b-col>
            </b-container>
            <b-container class="bg-problem py-5 my-5">
                <h3 class="text-white m-0">How can we support DMD gamers in their period of transition?</h3>
            </b-container>
            <!-- Solution -->
            <b-container class="my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Solution</h5>
                            <h3>EVO.</h3>
                            <p>A non-stigmatizing, ergonomic, and highly customizable game controller that evolves with DMD gamers.</p>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="banner">
                        <div>
                            <img class="rounded-img" src="../../assets/designProjects/evo/3-orientation.png" alt="">
                            <div class="banner-img-overlay"></div>
                        </div>
                        <div class="banner-des w-430">
                            <h4 class="text-white">A controller that can be ‘held’ and ‘placed’.</h4>
                            <p class="text-white">Allows DMD gamers to play while resting their arms on a table.</p>
                        </div>
                    </b-row>
                </b-col>
                <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col md class="my-2">
                            <div>
                                <h4>Minimized travel distance.</h4>
                                <p>Easier to reach triggers/bumpers for DMD gamers who find it hard to bend the second joint of their finger. </p>
                            </div>
                            <div>
                                <img src="../../assets/designProjects/evo/travel-distance.svg" alt="">
                            </div>
                        </b-col>
                        <b-col md class="my-2">
                            <div>
                                <h4>Lighter buttons and joysticks.</h4>
                                <p>Eliminates the main cause of discomfort with mainstream controllers. </p>
                            </div>
                            <div>
                                <img src="../../assets/designProjects/evo/activation-force.svg" alt="">
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="banner">
                        <div>
                            <img class="rounded-img" src="../../assets/designProjects/evo/EVO-prototype.png" alt="">
                            <div class="banner-img-overlay"></div>
                        </div>
                        <div class="banner-des w-430">
                            <h4 class="text-white">More options to experiment with.</h4>
                            <p class="text-white">The customizable joystick caps allows DMD gamers’ to find the optimal setup without spending extra.</p>
                        </div>
                    </b-row>
                </b-col>
            </b-container>
            <!-- Process -->
            <b-container class="my-5">
                <b-col class="col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                    <a v-b-toggle:collapse-process class="toggle-link mt-5">
                        <h2 class="mt-5 mb-4">Process
                        <span class="mt-4 mb-5">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-plus" viewBox="0 0 20 20">
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                            </svg>
                        </span>
                        </h2>
                    </a>
                    </b-row>
                </b-col>
            </b-container>
            <b-collapse id="collapse-process">
                <b-container class="bg-custom py-5 my-5">
                    <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                        <b-row>
                            <b-col class="my-2 w-50">
                                <h5 class="text-info">Design brief</h5>
                                <h3>“Develop an esports-worthy game controller for people with muscle weakness in the hands.”</h3>
                                <p>The target group is composed of males with Duchenne Muscular Dystrophy (DMD) who are interested in video gaming. DMD, is a genetic disease that causes progressive muscle weakness throughout the body. As reference, for every 4500 males born, 1 male is born with DMD. Boys with DMD game to socialize, gain freedom and as a form of entertainment. </p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-container>
                <b-container class="my-5">
                    <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                        <b-row>
                            <b-col class="my-2">
                                <h5 class="text-info">Discover</h5>
                                <h3>Understanding DMD gamers.</h3>
                                <p>Our journey started by talking to 11 DMD gamers from across 3 countries and 4 researchers about their experience with gaming.</p> 
                                <p>Through these interviews, we found that:</p>
                                <ul>
                                    <li>Users game predominantly in wheelchairs with support tables, sometimes with special standing frames. </li>
                                    <li>DMD gamers learn to use traditional game controllers during the early stages.</li>
                                    <li>Late-stage users generally require highly customized controllers to continue gaming. </li>
                                    <li>Gaming plays a significant role in Duchenne boys’ social and personal lives. </li>
                                    <li>Transitioning to an adaptive controller is mentally a big step for DMD gamers.</li>
                                </ul>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/progression-map.png" alt=""></b-col>
                        </b-row>
                    </b-col>
                </b-container>
                <b-container class="bg-custom py-5 my-5">
                    <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                        <b-row>
                            <b-col class="my-2">
                                <h5 class="text-info">Define</h5>
                                <h3>Our vision.</h3>
                                <p>Using what we discovered in the discover phase, we formulated a vision. It was to “develop a gaming controller that enables people with muscular dystrophy to confidently and competently game throughout the course of their disease.”</p>
                                <p>Accordingly, we created a requirements list for the final solution.</p>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/lor.png" alt=""></b-col>
                        </b-row>
                    </b-col>
                </b-container>
                <b-container>
                    <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                        <b-row>
                            <b-col class="my-2">
                                <h5 class="text-info">Ideation</h5>
                                <h3>4 concept directions.</h3>
                                <p>Based on the compiled requirements, we started brainsorming ideas. Our initial ideas were then evaluated using a c-box to determine 4 concept directions.</p>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/ideation.png" alt=""></b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/C-box.png" alt=""></b-col>
                        </b-row>
                        
                    </b-col>
                    <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                        <b-row>
                            <b-col class="my-2">
                                <h5 class="text-info">Conceptualization</h5>
                                <h3>The design freeze.</h3>
                                <p>Out of the four concept directions, a further evaluation using weighted objectives helped us reach a concept.</p>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <img class="rounded-img" src="../../assets/designProjects/evo/Concept directions.png" alt="">
                            <img class="rounded-img" src="../../assets/designProjects/evo/EVO ONE.png" alt="">
                        </b-row>
                    </b-col>
                    <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                        <b-row>
                            <b-col class="my-2">
                                <h5 class="text-info">Iteration</h5>
                                <h3>Prototypes and more prototypes.</h3>
                                <p>To further develop and to test our concept, we started creating multiple 3D printed prototypes while also working on the internal components such as the microcontroller, buttons, and joystick.</p>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <div class="my-3">
                                <h3 class="text-light pl-3">Prototype 1</h3>
                                <img class="rounded-img" src="../../assets/designProjects/evo/iteration-CP1.png" alt="">
                            </div>
                            <div class="my-3">
                                <h3 class="text-light pl-3">Prototype 2</h3>
                                <img class="rounded-img" src="../../assets/designProjects/evo/iteration-CP2.png" alt="">
                            </div>
                            <div class="my-3">
                                <h3 class="text-light pl-3">Final prototype</h3>
                                <img class="rounded-img" src="../../assets/designProjects/evo/iteration-FP.png" alt="">
                            </div>
                            <img class="rounded-img" src="../../assets/designProjects/evo/iteration-shape.png" alt="">
                        </b-row>
                    </b-col>
                    <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                        <b-row>
                            <b-col class="my-2">
                                <h5 class="text-info">Evaluation</h5>
                                <h3>User testing.</h3>
                                <p>The final evaluation was done with 3 DMD gamers. We brought the prototype to the participants, where they played a game with the prototype.</p>
                                <p>Through the test, we learned the following:</p>
                                <ul>
                                    <li>The bridged and tabletop configurations show potential for the participants and are worth pursuing for future development. </li>
                                    <li>The separate handheld configuration was not suitable for the participants and thus not worth pursuing. </li>
                                    <li>The controller requires an overall decrease in size to align with the user’s reach.</li>
                                    <li>The lighter joystick and buttons were both found to be an improvement over existing controllers. </li>
                                    <!-- <li>Long-term in-person testing with the user is advised due to the complex nature in use behavior of the target group. </li> -->
                                </ul>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/evaluation.png" alt=""></b-col>
                        </b-row>
                    </b-col>
                </b-container>
                <b-container class="bg-custom py-5 my-5">
                    <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                        <b-row>
                            <b-col class="my-2">
                                <h5 class="text-info">team</h5>
                                <h3>Reflection.</h3>
                                <p>As the user testing showed, the final prototype did not deliver an adequately functioning design to users. However, as a team, we proudly stand behind the robust research, development, and testing that were 
conducted. As part of a larger project, we hope the insights become a driver for the next project, and bring Yumen Bionics one step closer to an acessible game controller for DMD gamers.</p>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/team.jpg" alt=""></b-col>
                        </b-row>
                    </b-col>
                </b-container>
            </b-collapse>
            
        </div>
        <footerProjects></footerProjects>
    </div>
</template>

<script>
import csvData from '../../data/designProjectInfo.csv'
const Header = () => import('../../components/Header.vue')
const footerProjects = () => import('../../components/footerProjects.vue')

  var now = 'evo';

  export default {
    name: 'evo',
    title: 'EVO',
    components: {
      'Header': Header,
      'footerProjects': footerProjects,
    },
    data: () => {
      return {
        items : csvData
      }
    },
    computed: {
      projNow() {
        return this[this.$i18n.locale].filter((item) => item.code == now);
      },
      ja() {
        return this.items.filter((item) => item.lang == 'ja' );
      },
      en() {
        return this.items.filter((item) => item.lang == 'en');
      },
      path() {
        return this.item.path;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="@/scss/designProjects.scss">
</style>